module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsMaks),
      expression: "tipsMaks"
    }],
    staticClass: "tips-mask-t",
    on: {
      "click": _vm.onCancel
    }
  }, [_c('div', {
    staticClass: "tips-wrapper",
    class: {
      'tips-start': _vm.topMove, 'tips-end': !_vm.topMove
    }
  }, [(_vm.tipsFont) ? _c('div', {
    staticClass: "tips-font"
  }, [_c('p', [_vm._v(_vm._s(_vm.tipsFont))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tips-btns"
  }, [_vm._l((_vm.btnFont), function(btn, index) {
    return _c('a', {
      staticClass: "tips-two-btn tips-marbot red-font",
      on: {
        "click": function($event) {
          return _vm.onSelect(index)
        }
      }
    }, [_vm._v(_vm._s(btn))])
  }), _vm._v(" "), (_vm.cancelFont) ? _c('a', {
    staticClass: "tips-two-btn",
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelFont))]) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f352dad!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TipsSelect.vue
// module id = 544
// module chunks = 1